import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useFooterCta } from './hooks/useFooterCta';

export const FooterCta: React.FC = () => {
	const { actions } = useFooterCta();

	return (
		<section id="sign" className="bg-fill-brand-strong py-16 lg:py-24">
			<div className="container">
				<div className="mx-auto flex max-w-xl flex-col items-center gap-4 text-center">
					<Text
						as="span"
						variant="body"
						size="small"
						fontWeight="bold"
						className="text-typography-inverse-strong-fixed tracking-wide uppercase"
					>
						<Translate value="corgi.ambassadors.footer_cta.eyebrow" />
					</Text>
					<Text as="h2" variant="heading" size="large" className="text-typography-inverse-strong-fixed">
						<Translate value="corgi.ambassadors.footer_cta.heading" />
					</Text>
					<Text as="p" variant="body" size="large" fontWeight="bold" className="text-typography-inverse-strong-fixed">
						<Translate value="corgi.ambassadors.footer_cta.eligibility" />
					</Text>
					<Text as="p" variant="body" size="large" className="text-typography-inverse-strong-fixed">
						<Translate value="corgi.ambassadors.footer_cta.body" />
					</Text>
					<Button
						variant="secondary-inverse"
						// `secondary-inverse` borders come from `stroke-inverse-strong`, which flips dark while
						// this band stays brand red. That token has no `-fixed` variant.
						className="before:border-white"
						onClick={actions.handleCtaClick}
						data-qa="ambassadors-footer-cta"
					>
						<Translate value="corgi.ambassadors.footer_cta.button" />
					</Button>
				</div>
			</div>
		</section>
	);
};
